export default "<app-quest></app-quest>\n"